/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "yue-Hans": {
        "year": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年后"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "旧年"
        },
        "year-short": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年后"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "旧年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年后"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "旧年"
        },
        "quarter": {
          "0": "今季",
          "1": "下一季",
          "future": {
            "other": "{0} 季后"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上一季"
        },
        "quarter-short": {
          "0": "今季",
          "1": "下季",
          "future": {
            "other": "{0} 季后"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上季"
        },
        "quarter-narrow": {
          "0": "今季",
          "1": "下季",
          "future": {
            "other": "{0} 季后"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上季"
        },
        "month": {
          "0": "今个月",
          "1": "下个月",
          "future": {
            "other": "{0} 个月后"
          },
          "past": {
            "other": "{0} 个月前"
          },
          "-1": "上个月"
        },
        "month-short": {
          "0": "今个月",
          "1": "下个月",
          "future": {
            "other": "{0} 个月后"
          },
          "past": {
            "other": "{0} 个月前"
          },
          "-1": "上个月"
        },
        "month-narrow": {
          "0": "今个月",
          "1": "下个月",
          "future": {
            "other": "{0} 个月后"
          },
          "past": {
            "other": "{0} 个月前"
          },
          "-1": "上个月"
        },
        "week": {
          "0": "今个星期",
          "1": "下星期",
          "future": {
            "other": "{0} 个星期后"
          },
          "past": {
            "other": "{0} 个星期前"
          },
          "-1": "上星期"
        },
        "week-short": {
          "0": "今个星期",
          "1": "下星期",
          "future": {
            "other": "{0} 个星期后"
          },
          "past": {
            "other": "{0} 个星期前"
          },
          "-1": "上星期"
        },
        "week-narrow": {
          "0": "今个星期",
          "1": "下星期",
          "future": {
            "other": "{0} 个星期后"
          },
          "past": {
            "other": "{0} 个星期前"
          },
          "-1": "上星期"
        },
        "day": {
          "0": "今日",
          "1": "听日",
          "2": "后天",
          "future": {
            "other": "{0} 日后"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前天",
          "-1": "寻日"
        },
        "day-short": {
          "0": "今日",
          "1": "听日",
          "2": "后天",
          "future": {
            "other": "{0} 日后"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前天",
          "-1": "寻日"
        },
        "day-narrow": {
          "0": "今日",
          "1": "听日",
          "2": "后天",
          "future": {
            "other": "{0} 日后"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前天",
          "-1": "寻日"
        },
        "hour": {
          "0": "呢个小时",
          "future": {
            "other": "{0} 小时后"
          },
          "past": {
            "other": "{0} 小时前"
          }
        },
        "hour-short": {
          "0": "呢个小时",
          "future": {
            "other": "{0} 小时后"
          },
          "past": {
            "other": "{0} 小时前"
          }
        },
        "hour-narrow": {
          "0": "呢个小时",
          "future": {
            "other": "{0} 小时后"
          },
          "past": {
            "other": "{0} 小时前"
          }
        },
        "minute": {
          "0": "呢分钟",
          "future": {
            "other": "{0} 分钟后"
          },
          "past": {
            "other": "{0} 分钟前"
          }
        },
        "minute-short": {
          "0": "呢分钟",
          "future": {
            "other": "{0} 分钟后"
          },
          "past": {
            "other": "{0} 分钟前"
          }
        },
        "minute-narrow": {
          "0": "呢分钟",
          "future": {
            "other": "{0} 分钟后"
          },
          "past": {
            "other": "{0} 分钟前"
          }
        },
        "second": {
          "0": "宜家",
          "future": {
            "other": "{0} 秒后"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-short": {
          "0": "宜家",
          "future": {
            "other": "{0} 秒后"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-narrow": {
          "0": "宜家",
          "future": {
            "other": "{0} 秒后"
          },
          "past": {
            "other": "{0} 秒前"
          }
        }
      },
      "yue": {
        "nu": ["latn"],
        "year": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "舊年"
        },
        "year-short": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "舊年"
        },
        "year-narrow": {
          "0": "今年",
          "1": "下年",
          "future": {
            "other": "{0} 年後"
          },
          "past": {
            "other": "{0} 年前"
          },
          "-1": "舊年"
        },
        "quarter": {
          "0": "今季",
          "1": "下一季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上一季"
        },
        "quarter-short": {
          "0": "今季",
          "1": "下季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上季"
        },
        "quarter-narrow": {
          "0": "今季",
          "1": "下季",
          "future": {
            "other": "{0} 季後"
          },
          "past": {
            "other": "{0} 季前"
          },
          "-1": "上季"
        },
        "month": {
          "0": "今個月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "month-short": {
          "0": "今個月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "month-narrow": {
          "0": "今個月",
          "1": "下個月",
          "future": {
            "other": "{0} 個月後"
          },
          "past": {
            "other": "{0} 個月前"
          },
          "-1": "上個月"
        },
        "week": {
          "0": "今個星期",
          "1": "下星期",
          "future": {
            "other": "{0} 個星期後"
          },
          "past": {
            "other": "{0} 個星期前"
          },
          "-1": "上星期"
        },
        "week-short": {
          "0": "今個星期",
          "1": "下星期",
          "future": {
            "other": "{0} 個星期後"
          },
          "past": {
            "other": "{0} 個星期前"
          },
          "-1": "上星期"
        },
        "week-narrow": {
          "0": "今個星期",
          "1": "下星期",
          "future": {
            "other": "{0} 個星期後"
          },
          "past": {
            "other": "{0} 個星期前"
          },
          "-1": "上星期"
        },
        "day": {
          "0": "今日",
          "1": "聽日",
          "2": "後天",
          "future": {
            "other": "{0} 日後"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前天",
          "-1": "尋日"
        },
        "day-short": {
          "0": "今日",
          "1": "聽日",
          "2": "後天",
          "future": {
            "other": "{0} 日後"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前天",
          "-1": "尋日"
        },
        "day-narrow": {
          "0": "今日",
          "1": "聽日",
          "2": "後天",
          "future": {
            "other": "{0} 日後"
          },
          "past": {
            "other": "{0} 日前"
          },
          "-2": "前天",
          "-1": "尋日"
        },
        "hour": {
          "0": "呢個小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "hour-short": {
          "0": "呢個小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "hour-narrow": {
          "0": "呢個小時",
          "future": {
            "other": "{0} 小時後"
          },
          "past": {
            "other": "{0} 小時前"
          }
        },
        "minute": {
          "0": "呢分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "minute-short": {
          "0": "呢分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "minute-narrow": {
          "0": "呢分鐘",
          "future": {
            "other": "{0} 分鐘後"
          },
          "past": {
            "other": "{0} 分鐘前"
          }
        },
        "second": {
          "0": "宜家",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-short": {
          "0": "宜家",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        },
        "second-narrow": {
          "0": "宜家",
          "future": {
            "other": "{0} 秒後"
          },
          "past": {
            "other": "{0} 秒前"
          }
        }
      }
    },
    "availableLocales": ["yue-Hans", "yue-Hant", "yue"],
    "aliases": {
      "yue-CN": "yue-Hans-CN",
      "yue-HK": "yue-Hant-HK"
    },
    "parentLocales": {}
  });
}